var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchWholeWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 11h1v2h14v-2h1v3H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84 11h-.88v-.86h-.022q-.575.99-1.692.989q-.821 0-1.289-.435q-.462-.435-.462-1.155q0-1.542 1.816-1.794l1.649-.23q0-1.403-1.134-1.403q-.993 0-1.794.677v-.902q.811-.516 1.87-.516q1.938 0 1.938 2.052zm-.88-2.782L4.633 8.4q-.612.087-.924.307q-.311.215-.311.768q0 .402.284.66q.291.252.768.253a1.41 1.41 0 0 0 1.08-.457q.43-.462.43-1.165zm3.388 1.987h-.022V11h-.88V2.857h.88v3.61h.021q.651-1.095 1.902-1.096q1.058 0 1.654.741q.602.736.602 1.977q0 1.38-.672 2.213q-.671.827-1.837.827q-1.09 0-1.649-.924m-.022-2.218v.768q0 .682.44 1.16q.447.473 1.128.473q.8 0 1.252-.613q.456-.612.456-1.702q0-.919-.424-1.44t-1.15-.52q-.767 0-1.235.536q-.467.532-.467 1.338"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchWholeWord);
export default __webpack_public_path__ + "static/media/match-whole-word.e88a23725c7baff31f660dfb4d5d603f.svg";
export { ForwardRef as ReactComponent };